<nsa-spinner></nsa-spinner>

@if(!isLogin() && !isErrorPage()) {
  @if(user(); as user) {
    <nsa-header
      nsaId="nsf-header"
      appName="APP_NAME"
      [translationParams]="{ environment: environment(), version: version() }"
      [profileName]="user.name"
      [profileSurname]="user.lastname"
      [actions]="headerActions"
      class="sticky top-0 z-[var(--z-header)]"
      (brandClick)="onBrandClick()"
      (profileClick)="onProfileClick()"
      (logout)="onLogout()">
    </nsa-header>
  }
}

<main [ngClass]="{ 'max-w-6xl mx-auto px-6 py-2 mt-10': !isLogin() && !isErrorPage() }">
  <nsa-breadcrumb
    className="mb-6"
    [homePage]="{ url: '', label: 'DASHBOARD.LABEL' }">
  </nsa-breadcrumb>

  <router-outlet></router-outlet>
</main>

@if(!isLogin() && !isErrorPage()) {
  <button
    type="button"
    class="fixed bottom-8 right-8 z-[1000] w-12 h-12 rounded-full bg-primary-600 text-white shadow-lg grid place-items-center cursor-pointer hover:bg-primary-700 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
    aria-label="Assistenza"
    title="Assistenza"
    (click)="onHelpClick()">
    <span class="material-symbols-outlined text-[28px]" aria-hidden="true">support_agent</span>
  </button>
}
